import Vue from "vue";
import VueRouter from "vue-router";
import VueFormulate from "@braid/vue-formulate";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./translation";

Vue.use(VueFormulate);
Vue.config.productionTip = false;

// Suppress "Redirected when going from X to Y via a navigation guard" in dev overlay.
// Vue Router rejects the original navigation when a guard redirects; that rejection is uncaught.
window.addEventListener("unhandledrejection", (event) => {
  if (event.reason && VueRouter.isNavigationFailure && VueRouter.isNavigationFailure(event.reason)) {
    event.preventDefault();
  }
});

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
